import { render, staticRenderFns } from "./emailSettingsImage.vue?vue&type=template&id=4d9c9e1a&scoped=true&"
import script from "./emailSettingsImage.vue?vue&type=script&lang=js&"
export * from "./emailSettingsImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9c9e1a",
  null
  
)

export default component.exports